/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';

function TitleRow({
  isFieldDisplay,
  title,
  optional,
  filter,
  showCondensedView,
  style = {},
  titleStyle = {},
}) {
  const textClassName = isFieldDisplay ? 'form-field-display-title' : 'form-field-title';
  return (
    <Row
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...!optional ? { className: 'form-required-field' } : {}}
      justify="start"
      style={{ width: '100%', ...style }}
    >
      <Col style={titleStyle} className={textClassName}>{title}</Col>
      <Col flex="auto">
        <Row justify={showCondensedView ? '' : 'end'}>
          {filter}
        </Row>
      </Col>
    </Row>
  );
}

TitleRow.propTypes = {
  isFieldDisplay: PropTypes.bool,
  title: PropTypes.string.isRequired,
  optional: PropTypes.bool,
  filter: PropTypes.node,
  showCondensedView: PropTypes.bool,
  style: PropTypes.object,
  titleStyle: PropTypes.object,
};

TitleRow.defaultProps = {
  isFieldDisplay: false,
  optional: false,
  filter: null,
  showCondensedView: false,
  style: {},
  titleStyle: {},
};

export default TitleRow;
